export default function PaymentSaveQRButton({ qr }) {
  if (!qr?.qr_base64) return null;
  function base64ToBlob(base64, mime = "image/png") {
    const cleanBase64 = base64.includes(",") ? base64.split(",")[1] : base64;

    const byteCharacters = atob(cleanBase64);
    const byteNumbers = new Array(byteCharacters.length);

    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    return new Blob([new Uint8Array(byteNumbers)], { type: mime });
  }

  async function saveQrFromBase64(qrBase64, filename = "payment-qr.png") {
    try {
      const blob = base64ToBlob(qrBase64);
      const file = new File([blob], filename, { type: blob.type });

      // ✅ Web Share API (มือถือ)
      if (navigator.canShare && navigator.canShare({ files: [file] })) {
        await navigator.share({
          files: [file],
          title: "QR Payment",
          text: "บันทึก QR สำหรับชำระเงิน",
        });
        return { method: "share" };
      }

      // ✅ fallback download
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);

      return { method: "download" };
    } catch (err) {
      console.error("saveQrFromBase64 error:", err);
      throw err;
    }
  }

  const handleSave = async () => {
    try {
      await saveQrFromBase64(qr.qr_base64);
    } catch {
      alert("ไม่สามารถบันทึก QR ได้");
    }
  };

  return (
    <button
      type="button"
      className="btn btn-secondary w-50 mt-2"
      onClick={handleSave}
    >
      💾 บันทึก QR
    </button>
  );
}
